import { KeyboardDatePicker } from 'seagull';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const toFromErrorMessage = 'To date must be after from date';
const DateRangePicker = _ref => {
  let {
    fromDate,
    toDate,
    testId,
    dateLimits = {},
    onChange,
    onInputBlur,
    onInputFocus
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(KeyboardDatePicker, {
      label: "From",
      testId: testId && "".concat(testId, "-from"),
      value: fromDate,
      minDate: dateLimits.min,
      maxDate: toDate,
      minDateMessage: dateLimits.minDateMessage,
      maxDateMessage: toFromErrorMessage,
      onChange: function (_onChange) {
        function onChange(_x) {
          return _onChange.apply(this, arguments);
        }
        onChange.toString = function () {
          return _onChange.toString();
        };
        return onChange;
      }(date => date && onChange({
        fromDate: date,
        toDate
      })),
      onFocus: onInputFocus,
      onBlur: onInputBlur
    }), /*#__PURE__*/_jsx(KeyboardDatePicker, {
      label: "To",
      testId: testId && "".concat(testId, "-to"),
      value: toDate,
      minDate: fromDate,
      maxDate: dateLimits.max,
      minDateMessage: toFromErrorMessage,
      maxDateMessage: dateLimits.maxDateMessage,
      onChange: function (_onChange2) {
        function onChange(_x2) {
          return _onChange2.apply(this, arguments);
        }
        onChange.toString = function () {
          return _onChange2.toString();
        };
        return onChange;
      }(date => date && onChange({
        fromDate,
        toDate: date
      })),
      onFocus: onInputFocus,
      onBlur: onInputBlur
    })]
  });
};
export default DateRangePicker;